/* eslint-disable */
import React, { useContext } from 'react'
import { Link, useLocation } from 'react-router-dom'
import styles from './index.module.scss'
import PageTitle from '../../core/pageTitle'
import { PageContext } from '../../../context/PageContextProvider'
import termsData from '../../../pages/term&conditions/termsData.json'

const tabs = [
  { key: 'term', path: '/term-conditions', label: { AZ: 'İstifadə Qaydaları', ENG: 'Terms of Service', RU: 'Условия использования', TR: 'Kullanım Koşulları' } },
  { key: 'privacy', path: '/privacy', label: { AZ: 'Məxfilik Siyasəti', ENG: 'Privacy Policy', RU: 'Политика конфиденциальности', TR: 'Gizlilik Politikası' } },
  { key: 'cookie', path: '/cookie-policy', label: { AZ: 'Kuki Siyasəti', ENG: 'Cookie Policy', RU: 'Политика cookie', TR: 'Çerez Politikası' } },
  { key: 'notices', path: '/legal-notices', label: { AZ: 'Hüquqi Bildirişlər', ENG: 'Legal Notices', RU: 'Юридические уведомления', TR: 'Yasal Bildirimler' } },
  { key: 'disclaimer', path: '/disclaimer', label: { AZ: 'Məsuliyyətdən İmtina', ENG: 'Disclaimer', RU: 'Отказ от ответственности', TR: 'Sorumluluk Reddi' } },
]

const TermPage = ({ currentKey, title: propTitle, text: propText, className }) => {
  const { language, theme } = useContext(PageContext)
  const location = useLocation()

  // Determine active tab key
  let activeKey = currentKey
  if (!activeKey) {
    if (location.pathname.includes('privacy')) activeKey = 'privacy'
    else if (location.pathname.includes('cookie')) activeKey = 'cookie'
    else if (location.pathname.includes('legal')) activeKey = 'notices'
    else if (location.pathname.includes('disclaimer')) activeKey = 'disclaimer'
    else activeKey = 'term'
  }

  const activeData = termsData[activeKey] || termsData.term
  const displayTitle = propTitle || (activeData.title && activeData.title[language]) || activeData.title.AZ
  const displaySections = (activeData.sections && activeData.sections[language]) || activeData.sections.AZ || propText || []

  return (
    <section className={`${styles.container} ${className}`}>
      <div>
        {/* Interactive Tab Navigation */}
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '10px',
          justifyContent: 'center',
          width: '100%',
          paddingBottom: '20px',
          borderBottom: '1px solid var(--bpg-border-subtle, #E2E8F0)'
        }}>
          {tabs.map((tab) => {
            const isActive = tab.key === activeKey
            return (
              <Link
                key={tab.key}
                to={tab.path}
                style={{
                  padding: '10px 18px',
                  borderRadius: '24px',
                  fontSize: '14px',
                  fontWeight: isActive ? '600' : '500',
                  color: isActive ? '#FFFFFF' : 'var(--bpg-text-secondary, #4A5568)',
                  backgroundColor: isActive ? 'var(--bpg-blue, #416db4)' : 'var(--bpg-bg-surface, #EDF2F7)',
                  border: isActive ? '1px solid var(--bpg-blue, #416db4)' : '1px solid var(--bpg-border-subtle, #E2E8F0)',
                  textDecoration: 'none',
                  transition: 'all 0.2s ease-in-out',
                  display: 'inline-block'
                }}
              >
                {tab.label[language] || tab.label.AZ}
              </Link>
            )
          })}
        </div>

        <PageTitle>{displayTitle}</PageTitle>

        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {displaySections.map((item, i) => {
            const parts = item.split(': ')
            const hasPrefix = parts.length > 1 && parts[0].length < 40
            return (
              <div
                key={i}
                style={{
                  padding: '20px 24px',
                  borderRadius: '14px',
                  backgroundColor: 'var(--bpg-bg-card, #FFFFFF)',
                  border: '1px solid var(--bpg-border-subtle, #E2E8F0)',
                  boxShadow: 'var(--bpg-shadow-card, 0 1px 3px rgba(0,0,0,0.05))',
                  lineHeight: '1.75',
                  fontSize: '15px',
                  color: 'var(--bpg-text-primary, #2D3748)'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      minWidth: '30px',
                      height: '30px',
                      borderRadius: '50%',
                      backgroundColor: theme === 'dark' ? 'rgba(65, 109, 180, 0.25)' : '#EBF8FF',
                      color: theme === 'dark' ? '#60a5fa' : '#0070BA',
                      border: theme === 'dark' ? '1px solid rgba(96, 165, 250, 0.3)' : '1px solid #BEE3F8',
                      fontWeight: '700',
                      fontSize: '13px'
                    }}
                  >
                    {i + 1}
                  </span>
                  <div>
                    {hasPrefix ? (
                      <>
                        <strong style={{ color: 'var(--bpg-text-primary, #1A202C)', fontSize: '16px' }}>{parts[0]}:</strong>{' '}
                        <span style={{ color: 'var(--bpg-text-secondary, #4A5568)' }}>{parts.slice(1).join(': ')}</span>
                      </>
                    ) : (
                      <span style={{ color: 'var(--bpg-text-secondary, #4A5568)' }}>{item}</span>
                    )}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default TermPage
